import { render } from "./VersionNotesDialog.vue?vue&type=template&id=5250c239&scoped=true"
import script from "./VersionNotesDialog.vue?vue&type=script&lang=js"
export * from "./VersionNotesDialog.vue?vue&type=script&lang=js"

import "./VersionNotesDialog.vue?vue&type=style&index=0&id=5250c239&scoped=true&lang=css"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5250c239"]])

export default __exports__